import React, { ChangeEvent, SFC } from 'react';
import styled from 'styled-components';

import { Card, Input } from 'antd';

interface CommentSectionProps {
    comments: string;
    newComment: string;
    isEditable: boolean;
    captura?: boolean;
    onNewCommentEdit: (newComment: string) => void;
}

const CommentsSectionWrapper = styled(Card)`
    margin-bottom: 24px !important;
    .ant-card-head {
        padding: 4px 40px !important;
    }
    .ant-card-head-title {
        font-size: 14px !important;
    }
    .ant-card-body {
        padding: 24px 40px !important;
    }
`;

const Pre = styled.pre`
    font: inherit;
    margin-bottom: 0px;
`;

const TextArea = styled(Input.TextArea)`
    margin-top: 24px;
`;

const CommentsSection: SFC<CommentSectionProps> = ({
    comments,
    newComment,
    isEditable,
    captura,
    onNewCommentEdit
}) => {
    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        onNewCommentEdit(event.target.value);
    };

    const placeholder = captura ? 'Añadir un nuevo comentario' : 'Obligatorio para rechazar';

    return (
        <CommentsSectionWrapper title="COMENTARIOS" bordered={false}>
            <Pre>{comments}</Pre>
            {isEditable && (
                <TextArea
                    rows={4}
                    onChange={handleChange}
                    value={newComment}
                    placeholder={placeholder}
                />
            )}
        </CommentsSectionWrapper>
    );
};

export default CommentsSection;
